import { render, staticRenderFns } from "./ItsLogisticMarketArrival.vue?vue&type=template&id=587443bd&scoped=true&"
import script from "./ItsLogisticMarketArrival.vue?vue&type=script&lang=js&"
export * from "./ItsLogisticMarketArrival.vue?vue&type=script&lang=js&"
import style0 from "./ItsLogisticMarketArrival.vue?vue&type=style&index=0&id=587443bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587443bd",
  null
  
)

export default component.exports